import { takeLatest, put } from 'redux-saga/effects';
import actionCreator from 'utils/actionCreator';
import axios from 'utils/axios';
import { bookingsActions } from './bookings';

/**
 * Action Types
 */
export const bookingsDeleteActionTypes = {
    REQUEST: '@app/bookings/delete/REQUEST',
    FAILURE: '@app/bookings/delete/FAILURE',
    SUCCESS: '@app/bookings/delete/SUCCESS',
}

/**
 * Redux Actions
 */
export const bookingsDeleteActions = {
    request: actionCreator(bookingsDeleteActionTypes.REQUEST),
    success: actionCreator(bookingsDeleteActionTypes.SUCCESS),
    failure: actionCreator(bookingsDeleteActionTypes.FAILURE)
};

/**
 * Saga Functions
 */
export const sagas = {
    *request({ payload, resolve, reject }) {
        try {
            const res = yield axios.delete(`/bookings/${payload}`);

            yield put(bookingsActions.delete(res.data.result));
            yield put(bookingsDeleteActions.success());

            resolve(res.data);
        } catch (err) {
            yield put(bookingsDeleteActions.failure(err.response.data.errors));
            reject(err);
        }
    }
}

/**
 * Saga Watchers
 */
export const bookingsDeleteWatchers = function* () {
    yield takeLatest(bookingsDeleteActionTypes.REQUEST, sagas.request)
}
